export const UPDATE_FRONT_PRICE_LIST_SUCCESS = 'UPDATE_FRONT_PRICE_LIST_SUCCESS';
export const FRONT_PRICE_LIST_SUCCESS = 'FRONT_PRICE_LIST_SUCCESS';
export const APPLY_FRONT_PRICE_LIST_CHANGES = 'APPLY_FRONT_PRICE_LIST_CHANGES';
